/* eslint-disable */window.__publicpath__=window.publicPath?window.publicPath:window.location.origin+'/';__webpack_public_path__=window.__publicpath__;